$(document).ready(function(){
    $('#select-a-category').change(function() {
        // Get the url to load
        $categoryUrl = $(this).val();

        // Goto the url
        window.location = $categoryUrl;
    });
});